/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Manage_ViewsInputs */

const en_story_manage_views = /** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`views`)
};

const es_story_manage_views = /** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vistas`)
};

const fr_story_manage_views = /** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vues`)
};

const de_story_manage_views = /** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufrufe`)
};

const id_story_manage_views = /** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tayangan`)
};

/** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */
const ja_story_manage_views = en_story_manage_views;

/** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */
const zh_story_manage_views = en_story_manage_views;

/** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */
const ar_story_manage_views = en_story_manage_views;

/** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */
const it_story_manage_views = en_story_manage_views;

/** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */
const ru_story_manage_views = en_story_manage_views;

/** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */
const pt_story_manage_views = en_story_manage_views;

/** @type {(inputs: Story_Manage_ViewsInputs) => LocalizedString} */
const ko_story_manage_views = en_story_manage_views;

/**
* | output |
* | --- |
* | "views" |
*
* @param {Story_Manage_ViewsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_manage_views = /** @type {((inputs?: Story_Manage_ViewsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Manage_ViewsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_manage_views(inputs)
	if (locale === "es") return es_story_manage_views(inputs)
	if (locale === "fr") return fr_story_manage_views(inputs)
	if (locale === "de") return de_story_manage_views(inputs)
	if (locale === "ja") return ja_story_manage_views(inputs)
	if (locale === "zh") return zh_story_manage_views(inputs)
	if (locale === "ar") return ar_story_manage_views(inputs)
	if (locale === "id") return id_story_manage_views(inputs)
	if (locale === "it") return it_story_manage_views(inputs)
	if (locale === "ru") return ru_story_manage_views(inputs)
	if (locale === "pt") return pt_story_manage_views(inputs)
	return ko_story_manage_views(inputs)
});